import { createContext,useState } from 'react';

const Context = createContext({
    permissions: [],
    setPermissions: () => {},
    checkHasPermission: () => {},
    businessId : '',
    setBusinessId: () => {}
});

const ContextProvider = ({ children }) => {
    const [permissions,setPermissions] = useState({});
    const [businessId,setBusinessId] = useState('');
    const checkHasPermission = (operation,menuId = null) => {
        if(!permissions.length)
            return false;
        return permissions.find(permission => permission.menuId == (menuId || localStorage.getItem('mI')) && permission.crudMap[`${operation}Value`] == 1);
    }

    return (
        <Context.Provider value={{permissions,setPermissions,checkHasPermission,businessId,setBusinessId}}>{children}</Context.Provider>
    )
}

export {
    Context,
    ContextProvider
}